module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.4@core-js/library/modules/_library.js
// module id = yW5O
// module chunks = 0